enum menuOptions {
    addContent = 'add_content',
    resourceDetails = 'resource_details',
    addCollection = 'add_collection',
    addNew = 'add_new',
    addProject = 'add_project',
}

export {menuOptions};